import {Injectable} from '@angular/core';
import {TaxpercentageSettingApi} from '../../../shared/nestjs/payroll/taxpercentage-setting.api';
import {ResponsePaging} from '../../../shared/nestjs/nest-responses';
import {
  RequestGetTaxPercentage,
  RequestTaxPercentage,
  ResponseGetTaxPercentage
} from '../../../shared/nestjs/payroll/taxpercentage-setting.dto';

@Injectable()
export class CompanyDataSetupMyBloc {
  constructor(
      private taxpercentageSettingApi: TaxpercentageSettingApi,
  ) {
  }

  async getTaxPercentage(payload: RequestGetTaxPercentage): Promise<ResponsePaging<ResponseGetTaxPercentage>> {
    try {
      return await this.taxpercentageSettingApi.gettaxpercentage(payload).toPromise();
    } catch (e) {
      await Promise.reject(e);
    }
  }

  async taxpercentage(payload: RequestTaxPercentage[]): Promise<any> {
    try {
      return await this.taxpercentageSettingApi.taxpercentage(payload).toPromise();
    } catch (e) {
      await Promise.reject(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/bloc/hr/payroll/company-data-setup-my.bloc.ts